import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { SHARED_IMPORTS } from 'src/app/utils/other/standalone-import';

@Component({
  selector: 'app-error-view',
  templateUrl: './error-view.component.html',
  styleUrl: './error-view.component.scss',
  standalone: true,
  imports: [SHARED_IMPORTS, ButtonModule, RouterModule]
})
export class ErrorViewComponent {}
